import React from 'react';
import { FloatButton, Card, SubCard, CardOptions } from './styles';
import { CSSTransition } from 'react-transition-group';
import { Core } from '..';
import '../core/styles/styles.css';
import { FocusBackground } from '../core/styles';

export const Float = ({ children }) => {
  return <>{children}</>;
};

Float.BotButton = function FloatBotButton({
  isHalf = null,
  forwardedRef = null,
  disabled,
  children,
  position,
  color,
  colorD2,
  hasScroll = null,
  ...restProps
}) {
  return (
    <FloatButton
      ref={forwardedRef}
      disabled={disabled}
      position={position}
      color={color}
      colorD2={colorD2}
      isHalf={isHalf}
      hasScroll={hasScroll}
    >
      <div>
        <div className='container' {...restProps}>
          <div>{children}</div>
        </div>
      </div>
    </FloatButton>
  );
};

Float.Card = function FloatCard({
  disabled,
  color,
  color_L2,
  showBox,
  setShowBox,
  type = 'default',
  children,
  ...restProps
}) {
  return (
    <>
      <FocusBackground
        zIndex={198}
        showBox={showBox}
        onClick={() => setShowBox(false)}
      ></FocusBackground>

      <Card disabled={disabled} color={color} color_L2={color_L2} type={type}>
        <CSSTransition
          in={showBox}
          timeout={300}
          classNames='display'
          unmountOnExit
        >
          <div>
            <div {...restProps}>{children}</div>
          </div>
        </CSSTransition>
      </Card>
    </>
  );
};

Float.SubCard = function FloatCard({ children, ...restProps }) {
  return <SubCard {...restProps}>{children}</SubCard>;
};

Float.CardChild = function FloatCardChild({ type, children, ...restProps }) {
  return (
    <CardOptions type={type} {...restProps}>
      {children}
    </CardOptions>
  );
};

Float.OptionHeader = function FloatOptionHeader({
  value,
  color,
  fun,
  children,
}) {
  return (
    <div style={{ justifyContent: 'space-between', display: 'flex', alignItems: 'center'}}>
      {children}
      <Core.Switch color={color} value={value} onClick={fun}></Core.Switch>
    </div>
  );
};
